module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-SemiBoldItalic.woff?9cfc8815561461a35ddbcb38319fb68f";